/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/NewProfile/Content/SchedulingPreferences/Content/Edit/Content/Time",
  onChange
  
}) {
let hoursValueData = fromData.useDataValue({ viewPath,
context: 'hours',
})
let preferencesStartHourValueData = fromData.useDataValue({ viewPath,
context: 'preferences',
path: 'start_hour',
})
let preferencesStartHourChangeData = fromData.useDataChange({ viewPath,
context: 'preferences',
path: 'start_hour',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let hoursValueData1 = fromData.useDataValue({ viewPath,
context: 'hours',
})
let preferencesEndHourValueData = fromData.useDataValue({ viewPath,
context: 'preferences',
path: 'end_hour',
})
let preferencesEndHourChangeData = fromData.useDataChange({ viewPath,
context: 'preferences',
path: 'end_hour',
})
  return (<React.Fragment
>
<div
  data-testid="Time.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginRight={dtSpaceXs}
 size="medium"
 data="hours"
 from={hoursValueData}
 data="preferences.start_hour"
 value={preferencesStartHourValueData}
 onChange={preferencesStartHourChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="From"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 size="medium"
 data="hours"
 from={hoursValueData1}
 data="preferences.end_hour"
 value={preferencesEndHourValueData}
 onChange={preferencesEndHourChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="To"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
</div>
{children}
</React.Fragment>)
}